import React from 'react';
import ResultModel from './ResultModel';
import CCOApiConnector from './CCOApiConnector';
import Progressbar from './Progressbar';

export default class CognitiveResult extends React.Component {

    state = {
        resultModels: []
    }


    componentDidMount = () => {

        let { app, quizViewer } = this.props
        let { quizViwerModel } = quizViewer.state
        let { resultModels } = this.state
        let ccoApiConnector = new CCOApiConnector()
        ccoApiConnector.getCognitiveList(res => {

            let cognitiveList = res.data.cognitiveListJson;


            resultModels = [];

            for (let i = 0; i < cognitiveList.length; i++) {

                resultModels.push(new ResultModel(cognitiveList[i].cognitiveId, cognitiveList[i].cognitiveNameAr, 0, 0, 0));

            }

            for (let i = 0; i < quizViwerModel.activityArr.length; i++) {
                let activity = quizViwerModel.activityArr[i];

                for (let k = 0; k < resultModels.length; k++) {

                    if (activity.cognitiveId == resultModels[k].id) {

                        resultModels[k].total++;
                        if (activity.answeredTrue) {
                            resultModels[k].right++;
                        } else {
                            resultModels[k].wrong++;
                        }
                    }
                }
            }

            

            //remove the empty cognitive
            // for (Iterator < ResultModel > iterator = resultModels.iterator(); iterator.hasNext(); ) {
            // ResultModel obj = iterator.next();
            // if (obj.total == 0) {
            //     // Remove the current element from the iterator and the list.
            //     iterator.remove();
            // }


            resultModels = resultModels.filter(obj => {
                return obj.total > 0
            })

            this.setState({ resultModels })

        });

    }




    render = () => {

        let { resultModels } = this.state

        return (
            <>
                {
                    resultModels.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <Progressbar resultModel={item} />
                            </React.Fragment>
                        )
                    })
                }
            </>
        )
    }


}